<template>
  <div v-if="visible" class="opc-open-invoice" :class="isIframesModal ? 'opc-open-invoice-modal' : ''">
    <h3 class="opc-cart-item__title text-capitalize">
      <span class="opc-cart-item__subtitle">
        {{ $t('billing.invoice.cart.label') }}
        <zm-tooltip style="display: inline-block !important;" v-if="showOpenInvoiceAmountTips">
          <div slot="content" v-if="openInvoiceTooltips" v-html="openInvoiceTooltips"></div>
          <div slot="content" v-else>
            <span>{{$t('billing.invoice.cart.with_credit_balance_desc', [$money(currentCreditBalance)])}}</span>
          </div>
          <i class="zm-icon-info-outline" style="position: relative; top: -1px; color: #666487; font-size: 16px; cursor: pointer;" />
        </zm-tooltip>
      </span>
      <span class="opc-cart-item__value text-no-capitalize">
        {{ openInvoiceTotalAmountView }}
      </span>
    </h3>
    <div class="opc-cart-item__text">
      {{ openInvoiceCountView }}
    </div>
    <zm-button class="opc-open-invoice__sub-item opc-success-no-hide-button" type="link" v-for="item in openInvoiceList"
               :key="item.invoiceNumber"
               @click="handleInvoicePreview(item)">
      {{ item.invoiceNumber }}
    </zm-button>
    <invoice-dialog
      :visible="invoicePreviewVisible"
      :invoice-number="currentSelectInvoiceNumber"
      @close="handleInvoiceDialogClose" />
  </div>
</template>

<script type="text/jsx">
import InvoiceDialog from '@/views/config/shopping-cart/open-invoice/invoice-dialog.vue';
import { isEmptyVal } from '@/utils';

export default {
  name: 'open-invoice-cart',
  components: { InvoiceDialog },
  data() {
    return {
      invoicePreviewVisible: false,
      currentSelectInvoiceNumber: null,
    };
  },
  props: {
    openInvoiceList: {
      type: Array,
      default: () => [],
    },
    openInvoiceTotalAmount: {
      type: Number,
      default: 0,
    },
    openInvoiceOriginalTotalAmount: {
      type: Number,
      default: 0,
    },
    currentCreditBalance: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isIframesModal() {
      return this.$context.is.modal;
    },
    openInvoiceTotalAmountView() {
      return this.$money(this.openInvoiceTotalAmount > 0 ? this.openInvoiceTotalAmount : 0);
    },
    openInvoiceCountView() {
      return this.$t('billing.invoice.cart.unit', [this.openInvoiceCount]);
    },
    openInvoiceCount() {
      return this.openInvoiceList?.length || 0;
    },
    visible() {
      return !isEmptyVal(this.openInvoiceList);
    },
    openInvoiceTooltips() {
      return this.getOpenInvoiceTooltips();
    },
    showOpenInvoiceAmountTips() {
      return this.currentCreditBalance > 0;
    },
  },
  methods: {
    handleInvoicePreview(item) {
      this.invoicePreviewVisible = true;
      this.currentSelectInvoiceNumber = item?.invoiceNumber;
    },
    handleInvoiceDialogClose() {
      this.invoicePreviewVisible = false;
    },
    getOpenInvoiceTooltips() {
      return window.campaignFlags?.getOpenInvoiceTooltips?.({
        openInvoiceOriginalTotalAmount: this.$money(this.openInvoiceOriginalTotalAmount),
        openInvoiceTotalAmount: this.$money(this.openInvoiceTotalAmount),
        currentCreditBalance: this.$money(this.currentCreditBalance),
      });
    },
  },
};
</script>

<style lang="scss">
.opc-open-invoice {
  padding-bottom: 8px;

  &.opc-open-invoice-modal {
    .opc-cart-item__subtitle {
      font-family: Almaden Sans;
      font-size: 18px;
      font-weight: 700;
      line-height: 27px;
    }
  }

  &__sub-item {
    &.zm-button {
      display: flex;
      padding: 0px !important;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
    }

    &.zm-button + .zm-button {
      margin-left: 0px !important;
    }
  }
}
</style>
